import React, { useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DesktopDatePicker as DatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { InputLabel, TextField, Typography, Box } from "@mui/material";
import moment from "moment";

export const FilterDataField = ({
  label,
  minDate,
  maxDate,
  requiredCancel,
  disabled,
  onValueChange,
  isRequired,
  ...props
}) => {
  const [selectedDate, setSelectedDate] = useState(null);

  return (
    <Box sx={{display:"flex",alignItems:"center"}}>
         {label && (
          <InputLabel shrink>
            <Typography variant="h5" sx={{ textTransform: "capitalize" }}>
              {label} :
            </Typography>
          </InputLabel>
        )}
      <LocalizationProvider dateAdapter={AdapterMoment} >
       
        <DatePicker
          value={selectedDate ? moment(selectedDate) : null}
          onChange={(value) => {
            const momentValue = moment(value);
            if (momentValue.isValid()) {
              setSelectedDate(momentValue.format("YYYY-MM-DD"));
              onValueChange?.(momentValue.format("YYYY-MM-DD"));
            } else {
              setSelectedDate(null);
            }
          }}
          minDate={minDate ? moment(minDate) : null}
          maxDate={maxDate ? moment(maxDate) : null}
          sx={{
            backgroundColor: "#F7F7F7",
            // borderRadius: "12px",
            fontSize:"12px",
            width: "auto",
            "& fieldset": { border: "none" },
            "& .MuiInputBase-input": { padding: "5px 10px" }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              error={false}
              fullWidth
              label={undefined}
              sx={{
                fontSize:"12px"
              }}
              disabled={disabled}
              {...props}
            />
          )}
          inputFormat="MM/DD/YYYY"
          componentsProps={
            requiredCancel ? {} : { actionBar: { actions: ["today", "cancel"] } }
          }
          disabled={disabled}
        />
      </LocalizationProvider>
    </Box>
  );
};
